import { Link } from 'react-router-dom';
import { PIXELUTILITY_URL, SUPPORT_URL } from '../../constants';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 bg-white py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="font-semibold text-slate-900">PixelUtility QR</p>
            <p className="mt-2 max-w-xs text-sm text-slate-600">
              Free, fast, privacy-friendly QR codes — no redirects, no sign-up.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm" aria-label="Footer">
            <Link to="/privacy" className="text-slate-600 hover:text-indigo-600">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-slate-600 hover:text-indigo-600">
              Terms
            </Link>
            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-600 hover:text-indigo-600"
            >
              Support
            </a>
            <a
              href={PIXELUTILITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-600 hover:text-indigo-600"
            >
              PixelUtility
            </a>
          </nav>
        </div>
        <p className="mt-8 text-xs text-slate-500">
          © {year} PixelUtility.{' '}
          <a
            href={SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-indigo-600"
          >
            Support
          </a>
        </p>
      </div>
    </footer>
  );
}
